import { ESeriesCategory } from '@reolink-cloud/interface';
import { RawLocation } from 'vue-router';

export class GetUserDataError extends Error {

    public isSimError = false;

    public constructor( message: string ) {

        super( message ); // (1)
        if ( message.toLocaleLowerCase().includes( 'sim' )) {

            this.isSimError = true;
        
        }
        this.name = 'GetUserDataError'; // (2)

    }

}

export class PlanDisabledError extends Error {

    public constructor( public readonly redirectArgs:  RawLocation ) {

        super( 'Plan is disabled' );
        this.name = 'PlanDisabledError';

    }
    
}

export class SubscriptionProcessingError extends Error {

    public constructor() {

        super( 'Subscription is processing' );
        this.name = 'SubscriptionProcessingError';

    }
    
}
